export const VALIDATION_API_DEBOUNCE_TIME = 500;
export const IS_DEVELOPMENT = process.env.NODE_ENV === 'development';
export const IS_STAGING = process.env.ENV_MODE === 'staging';
export const IS_PRODUCTION = process.env.NODE_ENV === 'production';
